import { render, staticRenderFns } from "./DetailedViewSlotsBlock.vue?vue&type=template&id=07a9a832&"
import script from "./DetailedViewSlotsBlock.vue?vue&type=script&lang=js&"
export * from "./DetailedViewSlotsBlock.vue?vue&type=script&lang=js&"
import style0 from "./DetailedViewSlotsBlock.vue?vue&type=style&index=0&id=07a9a832&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports